export const asAsyncKeyMapSync = async (source, keySelector) => {
    const map = new Map();
    for (const item of source) {
        const key = await keySelector(item);
        const currentMapping = map.get(key);
        if (currentMapping) {
            currentMapping.push(item);
        }
        else {
            map.set(key, [item]);
        }
    }
    return map;
};
